import React from 'react';
import cn from 'classnames';

type AwardPaymentPageHeaderProps = {
  title: string;
  wrapperClassName?: string;
  rowClassName?: string;
  titleClassName?: string;
};

const styles = {
  wrapper: 'w-full pt-6 sm:pt-8 pb-2 sm:pb-8',
  row: 'w-full flex flex-col gap-4 md:flex-row md:items-center md:justify-between',
  title: 'text-blue text-2xl sm:text-h-lg font-extrabold font-serif leading-tight sm:leading-[60px]',
};

const AwardPaymentPageHeader = ({ title, wrapperClassName, rowClassName, titleClassName }: AwardPaymentPageHeaderProps) => (
  <div className={cn(styles.wrapper, wrapperClassName)}>
    <div className={cn(styles.row, rowClassName)}>
      <h1 className={cn(styles.title, titleClassName)}>{title}</h1>
    </div>
  </div>
);

export default AwardPaymentPageHeader;
